import React, {
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";

import "./swiper.css";
import uniqid from "uniqid";
import styled, { css } from "styled-components";

export default function PAslider({
  id,
  products = [],
  theme,
  cardWidth,
  cardType,
  template,
  handleActive = ()=> void(0),
  children
}) {



  const [uniqueId, setUniqueId] = useState(id || uniqid());
  const [slides, setSlides] = useState(products);

  useEffect(() => {
    if (products.length) {
      setSlides(products);
      global[`mySwiper_${uniqueId}`] && global[`mySwiper_${uniqueId}`].update();
    }
  }, [products]);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.innerHTML = `
      var mySwiper_${uniqueId} = new Swiper('#${uniqueId}', {
        direction: 'horizontal',
        slideToClickedSlide: true,
        setWrapperSize: true,
        // centeredSlides: true,
        breakpoints: {
          320: {
            // setWrapperSize: true,
            // centeredSlides: true,
            slidesPerView: 1,
            // spaceBetween: 40,
            speed: 250,
          },
          780: {
            // setWrapperSize: false,
            // centeredSlides: false,
            slidesPerView: 1,
            spaceBetween: 0,
          },
          3000: {
            // setWrapperSize: false,
            // centeredSlides: false,
            slidesPerView : 4,
            spaceBetween: 0,
            speed: 0,
            noSwipingClass: 'swiper-slide',
          },
        },



        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'bullets',
        // },
        // height: 400,



      });
      mySwiper_${uniqueId}.on('slideChange', function () {
        let nw = mySwiper_${uniqueId}.activeIndex;
        console.log('nw = ', nw);
        swiperHandle(nw)
      })
      mySwiper_${uniqueId}.on('click', function (e) {
        debugger
        let nw = mySwiper_${uniqueId}.clickedIndex;
        console.log('nw = ', nw);
        swiperHandle(nw)
      })
    `;
    // setTimeout(()=>{
      document.body.appendChild(script);
    // }, 200)
  }, [uniqueId]);

  return (
    <CSSswiperContainer
      className="swiper-container"
      id={uniqueId}
      style={{
        // color: theme["colorAccent"],
        // height: `${cardWidth ? cardWidth * 2 : 400}px`
      }}
    >
      {/* <div
        style={{
        }}
        className="swiper-button-next"
      >
        <svg style={{ opacity: slides.length > 1 ? 0.4 : 0 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z" fill="currentColor" /></svg>
      </div> */}

      {/* <div
        style={{
        }}
        className="swiper-button-prev"
      >
        <svg style={{ opacity: slides.length > 1 ? 0.4 : 0 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44" ><path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z" fill="currentColor" /> </svg>
      </div> */}

      <div
        className="swiper-pagination"
        style={{
          // color: theme["colorAccent"],
          opacity: slides.length > 1 ? 1 : 0
        }}
      ></div>
      <CSSswiperWrapper className="swiper-wrapper">

        {children}

      </CSSswiperWrapper>
    </CSSswiperContainer>
  );
}


const CSSswiperContainer = styled.div`
  width: 100%;
  @media (max-width: 768px) {

  }
`

const CSSswiperWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    display: block;
    justify-content: auto;
  }
`